import { render, staticRenderFns } from "./FooterExtended.vue?vue&type=template&id=f018c832&scoped=true&"
import script from "./FooterExtended.vue?vue&type=script&lang=js&"
export * from "./FooterExtended.vue?vue&type=script&lang=js&"
import style0 from "./FooterExtended.vue?vue&type=style&index=0&id=f018c832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f018c832",
  null
  
)

export default component.exports